<template>
  <div class="container">
    <div class="row mb-10 align-items-center">
      <div class="col-8">
        <div class="breadcrumb-list">
          <ol class="breadcrumb">
            <li aria-current="page" class="breadcrumb-item active">Customers</li>
          </ol>
        </div>
      </div>
      <div class="col-4 text-right ">
        <a href="#addCustomerModal" class="btn btn-primary btn-sm" data-toggle="modal"><span>Add</span></a>
        <a v-if="showDeleteButton" class="btn btn-danger btn-sm" @click="delCustomerData()" data-toggle="modal"><span>Delete</span></a>
      </div>
    </div>

    <div class="card">
      <div class="card-body p-0">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th> <span class="custom-checkbox">
                  <input type="checkbox" v-model="selectAll">
                  <label></label>
                </span>
                Customers Name
              </th>

            </tr>
          </thead>
          <tbody>

            <tr v-for="customer in customers" :key="customer.id">
              <td>
                <span class="custom-checkbox">
                  <input type="checkbox" class="customer_id_ckbx" :value="customer.id" v-model="selected"
                    v-on:change="selectedcustomer_id">
                  <label></label>
                </span>
               <span class="text-capitalize"> {{ customer.name }}</span>
                <a href="#EditCustomerModal" data-toggle="modal"><i class="ico-pencil float-right"
                    @click="editCustomer(customer.id)"> </i></a>
<!--                   <a @click="delCustomerData(customer.id)"><i class="ico ico-delete float-right" style="margin-right: 15px;" ></i></a>-->
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>

    <!-- Add Customer Modal HTML -->
    <div id="addCustomerModal" class="modal fade" v-if="modalShow">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="addCustomerData">
            <div class="modal-header">
              <h4 class="modal-title">Add Customers</h4>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control text-capitalize" required v-model="CustomerName" required>
              </div>
            </div>
            <div class="modal-footer">
              <input type="button" class="btn btn-light" data-dismiss="modal" value="Cancel">
              <input type="submit" :disabled="isAddBtnDisable" class="btn btn-primary" value="Add">
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Edit Customer Modal HTML -->
    <div id="EditCustomerModal" class="modal fade" v-if="modalShow">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="saveEditCustomer">
            <div class="modal-header">
              <h4 class="modal-title">Edit Customers</h4>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" v-model="EditCustomerName">
              </div>
            </div>
            <div class="modal-footer">
              <input type="button" class="btn btn-light" data-dismiss="modal" value="Cancel">
              <input type="submit" class="btn btn-primary" value="Update">
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2';
export default {
  name: 'customer',
  components: {
    Swal
  },
  data() {
    return {
      isAddBtnDisable: false,
      modalShow: true,
      customers: [],
      customersid: [],
      Allids: [],
      CustomerName: "",
      selected: [],
      EditCustomerName: "",
      EditCustomerid: null
    }
  },
  mounted() {
    this.getCustomerData();
    // this.addCustomerData();

  },
  methods: {
    async getCustomerData() {
      // this.loadingSpin = true;
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
        },
        url: this.$getCustomers,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.customers = res.data.result;
         // console.log(this.customers)
        }

      })
    },
    async addCustomerData() {
       this.isAddBtnDisable = true;
      this.$axios({
        method: "post",
        url: this.$createCustomers,
        headers: this.getAuthHeader(),
        data: {
          name: this.CustomerName,
          company_id: this.$store.getters.getSelectedCompany.id,
        }
      }).then((res) => {
        this.isAddBtnDisable = false;
        if (res.data.status == 200) {
          $('#addCustomerModal').modal('hide');
          this.getCustomerData();
          this.resetForm();
        }
      })
    },
    async delCustomerData(id) {
      if(this.Allids.length<=0){
        new Swal({
          title: "Please select customers",
          icon: "warning",
          // text: "Are you sure? You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Delete it!"
        })
      }else{
        new Swal({
          title: "Delete Customers?",
          icon: "warning",
          text: "Are you sure? You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Delete it!"
        }).then((result) => {
          if (result.value) {
            this.$axios({
              method: 'DELETE',
              params: {
                customers: this.Allids,
                company_id: this.$store.getters.getSelectedCompany.id,
              },
              url: this.$deleteCustomer,
              headers: this.getAuthHeader(),
            }).then((res) => {
              if (res.data.status == 200) {
                this.getCustomerData();
                this.selected = [];
                this.selectAll = false;
              }
            })
          }
        });
      }

    },
    selectedcustomer_id(id) {
      var ids = []
      $('input:checked.customer_id_ckbx').each((ind, element) => {
        let id = $(element).val();
        if (!ids.includes(id)) {
          ids.push(id);
        }
      });
      //  console.log(ids)
      this.Allids = ids;
    },
    resetForm() {
      this.CustomerName = null;
    },
    editCustomer(id) {
      let editCustomer = this.customers.filter(function (customer) {
        return customer.id == id;
      });
      if (editCustomer.length > 0) {

        this.EditCustomerName = editCustomer[0].name;
        this.EditCustomerid = editCustomer[0].id;

      }
    },
    async saveEditCustomer() {
     // console.log(this.EditCustomerid);
      this.$axios({
        method: "patch",
        data: {
          company_id: this.$store.getters.getSelectedCompany.id,
          name: this.EditCustomerName,
        },
        url: this.$customerUpdate.replace(":id", this.EditCustomerid),
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          $('#EditCustomerModal').modal('hide');
          this.getCustomerData();
          this.resetForm();
        }
      });
    },

  },
  computed: {
    selectAll: {
      get: function () {
        return this.customers ? this.selected.length == this.customers.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.customers.forEach(function (user) {
            selected.push(user.id);
          });
        }
        this.selected = selected;
        this.Allids = selected;
        //console.log(this.selected);
      }
    },
    showDeleteButton() {
      return this.selected.length > 0;
    },
  }
}
</script>

<style scoped>
.table tr {
  border: none !important;
}

.table td:first-child {
  width: 20px !important;
}

.table thead {
  background-color: #E9E9E9 !important;
}

.table thead th {
  border: none !important;
}

.table-striped>tbody>tr:nth-child(odd)>td,
.table-striped>tbody>tr:nth-child(odd)>th {
  background-color: #F7F7F7;
}

body {
  font-family: "Lato", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}
</style>

